import React, { useEffect } from "react"
import { Link } from "gatsby"

//styled components
import { HeaderNav, Logo, Menu } from "../styles/headerStyles"
import { Container, Flex } from "../styles/globalStyles"

import {
  useGlobalStateContext,
  useGlobalDispatchContext,
} from "../context/globalContext"

const isBrowser = typeof window !== "undefined"

const Header = ({ onCursor, setToggleMenu, toggleMenu }) => {
  const dispatch = useGlobalDispatchContext()
  const { currentTheme } = useGlobalStateContext()

  const toggleTheme = () => {
    if (currentTheme === "dark") {
      dispatch({ type: "TOGGLE_THEME", theme: "light" })
    } else {
      dispatch({ type: "TOGGLE_THEME", theme: "dark" })
    }
  }

  const menuHover = () => {
    onCursor("white")
  }

  useEffect(() => {
    isBrowser && window.localStorage.setItem("theme", currentTheme)
  }, [currentTheme])

  return (
    <HeaderNav
      animate={{ y: 0, opacity: 1 }}
      initial={{ y: -72, opacity: 0 }}
      transition={{ duration: 1, ease: [0.6, 0.05, -0.01, 0.9] }}
    >
      <Container>
        <Flex spaceBetween noHeight>
          <Logo
            onMouseEnter={() => onCursor("hovered")}
            onMouseLeave={onCursor}
          >
            <Link to="/">FURR</Link>
            <span
              onClick={toggleTheme}
              onMouseEnter={() => onCursor("pointer")}
              onMouseLeave={onCursor}
            ></span>
            <Link to="/">W</Link>
          </Logo>
          <Menu
            onClick={() => {
              // Unlock/resume the nav video synchronously inside this click
              // handler. The nav (and its video element) stay mounted in the
              // DOM at all times specifically so this element already exists
              // by the time this gesture fires — iOS Safari only treats
              // play() as gesture-driven when it runs in direct response to
              // the click, not later via a React effect after re-render.
              if (isBrowser) {
                const video = document.querySelector("[data-nav-video]")
                if (video) video.play().catch(() => {})
              }
              setToggleMenu(!toggleMenu)
            }}
            onMouseEnter={menuHover}
            onMouseLeave={onCursor}
          >
            <button>
              <span></span>
              <span></span>
            </button>
          </Menu>
        </Flex>
      </Container>
    </HeaderNav>
  )
}

export default Header
